module.exports = __webpack_public_path__ + "img/porsche.ea18f136.jpg";